import React from 'react';

import Person from '../../../../containers/Pages/ProfileEdit/Person';
import Information from '../../../../containers/Pages/Profile/Information';
import Link from '../../../Link';

import { Wrapper, Content, Gradient, StyledBack } from './styles';

const Index = () => {
  return (
    <Wrapper>
      <Content>
        <Link href="/profile">
          <StyledBack theme="black" themeMobile="black" />
        </Link>
        <Person />
        <Gradient />
        <Information />
      </Content>
    </Wrapper>
  );
};

export default Index;
